export const VIDEO_HEIGHT = 322;
export const VIDEO_WIDTH = 574;
export const CHART_HEIGHT = 216;
export const TIME_DISTRIBUTION_BAR_CHART_HEIGHT = 19;
export const TIME_DISTRIBUTION_BAR_CHART_WIDTH = 436;
